module.exports = __webpack_public_path__ + "media/images/category_icons/sports-6da57febb591c5877a43b8899c6b1f19.svg";